import { App, AppInfo } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
export interface IEnvironment {
  production: boolean;
  api: string;
  firebaseConfig: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
  stripePublishableKey: string;
  urlVoteNewSport: string;
  googleApiKey: string;
  activeSports: string[];
  version: Promise<string>;
  buildNumber: Promise<string>;
  /** Sentry DSN. Leave empty to disable error reporting for this environment. */
  sentryDsn: string;
  packageName: string;
  smartLinkBaseUrl: string;
  appLink: {
    uri: string;
  };
  ios: {
    appStoreId: string;
    bundleId: string;
  };
}

export const getInfo = async (): Promise<Pick<AppInfo, 'version' | 'build'>> => {
  if (Capacitor.isNativePlatform()) {
    return App.getInfo();
  }
  return {
    version: '1.0.0',
    build: '1',
  };
};
